<template>
  <a-popover :title="result && result.label" v-if="showPop">
    <template slot="content">
      <div class="content__list">
        <a-row v-for="(item, index) in result.details" :key="index">
          <a-col :span="8">{{ item.startTime }}s-{{ item.endTime }}s&nbsp;{{ item.label }}</a-col>
          <a-col :span="16">
            {{ item.text }}
          </a-col>
        </a-row>
      </div>
    </template>
    <slot></slot>
  </a-popover>
</template>

<script>
import {getResult} from '@/api/common.js'
export default {
  props: {
    url: {
      type: String,
      default: '',
      required: true
    },
    aliyunAudit: {
      type: Number,
      default: 0
    },
    xid: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      result: {
        label: '',
        details: []
      }
    }
  },
  computed: {
    showPop() {
      return this.aliyunAudit === 2 && this.result && this.result.label !== '正常'
    }
  },
  async mounted() {
    // 2 : 拒绝
    if (this.aliyunAudit !== 2) {
      this.result = null
      return
    }
    const { result } = await this.getResult()
    if (!result) {
      this.result = null
      return
    }
    const reason = result.find(item => item.content === this.url)

    if (!reason) {
      this.result = null
      return
    }
    const { label, details } = JSON.parse(reason.result)
    this.result.label = label
    let indexArr = new Set()
    const length = details.length
    details.forEach((element, index) => {
      if (element.label !== '正常') {
        indexArr.add(index)
        for (let i = 1; i <= 3; i++) {
          if (index - i >= 0) {
            indexArr.add(index - i)
          }
          if (index + i < length) {
            indexArr.add(index + i)
          }
        }
      }
    })
    indexArr = Array.from(indexArr)
    this.result.details = details.filter((item, index) => indexArr.includes(index))
  },
  methods: {
    getResult() {
      const [auditId, uninoId] = this.xid.split(',')
      return getResult({ auditId, uninoId })
    }
  }
}
</script>

<style scoped>
.content__list {
  width: 500px;
  max-height: 400px;
  overflow-y: auto;
}
</style>
